import React, { useEffect, useState } from "react";
import axios from "axios";
import { host } from "../../../api/ApiCalls";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../../../store/authStore";
import Lottie from "lottie-react";
import Loading from "../../../assets/Loading.json";
import { Search } from "lucide-react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import { tostifyOption } from "../../../utils/toastOptions";
pdfMake.vfs = pdfFonts.vfs;

const TeacherDashboard = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const [dashboardData, setDashboardData] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [dateFilter, setDateFilter] = useState("");
  const [downloadOption, setDownloadOption] = useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [menuOpenId, setMenuOpenId] = useState(null);

  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [courses, setCourses] = useState([]); // Your courses list
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingCourse, setEditingCourse] = useState(null); // Holds the course being edited
  const [courseToDelete, setCourseToDelete] = useState(null);
  const [formattedAvailability, setFormattedAvailability] = useState("");
 
  const [availability, setAvailability] = useState([]);
const [duration, setDuration] = useState(editingCourse?.duration || 0);
const [totalSessions, setTotalSessions] = useState(editingCourse?.totalSessions || 0);

const [image, setImage] = useState(null);
const [imagePreview, setImagePreview] = useState(editingCourse?.image || "");

const handleImageChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  setImage(file);

  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onloadend = () => {
    setImagePreview(reader.result);
  };
};



  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await axios.get(`${host}/api/teachers/dashboard`, {
          withCredentials: true,
        });
        setDashboardData(response.data);
        console.log("Dashboard Data:", response.data);
      } catch (error) {
        console.error("Error fetching teacher dashboard", error);
      }
    };

    fetchDashboardData();
  }, []);

  useEffect(() => {
  if (editingCourse) {
    setAvailability(editingCourse.availability || []);
    setDuration(editingCourse.duration || 0);
    setTotalSessions(editingCourse.totalSessions || 0);
  }
}, [editingCourse]);


  const parseAvailability = (input) => {
    return input.split("\n").map((line) => {
      const [day, slotsStr] = line.split(":");
      const slots = slotsStr.split(",").map((time) => {
        const [startTime, endTime] = time.trim().split("-");
        return { startTime: startTime.trim(), endTime: endTime.trim() };
      });
      return { day: day.trim(), slots };
    });
  };

  const handleCourseSubmit = async (e) => {
    e.preventDefault();
     // 👇 Upload image if a new one is selected
  let imageUrl = editingCourse?.image;
  if (image) {
    const formDataImage = new FormData();
    formDataImage.append("image", image);

    const imageUploadRes = await axios.post(
      `${host}/api/upload/upload`,
      formDataImage,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    imageUrl = imageUploadRes.data.url;
  }
    const formData = new FormData(e.target);

    const title = formData.get("title");
  const description = formData.get("description");
  const price = parseFloat(formData.get("price"));

   if (!title || !description || isNaN(price)) {
    alert("⚠️ Please fill all required fields properly.");
    return;
  }
    const updatedCourse = {
      title,
      description,
      price,
      totalSessions,
      duration,
      image: imageUrl,
      categories: editingCourse?.categories,
      availability,
    };

    // await updateCourse(editingCourse._id, updatedCourse);
    const updated = await updateCourse(editingCourse._id, updatedCourse);

  if (updated) {
    // ✅ Locally update offeredCourses inside dashboardData
    setDashboardData((prev) => ({
      ...prev,
      offeredCourses: prev.offeredCourses.map((course) =>
        course._id === updated._id ? updated : course
      ),
    }));
  }
    setIsModalOpen(false);
    setEditingCourse(null);
  };

  const updateCourse = async (courseId, updatedData) => {
    try {
      const response = await axios.put(
        `${host}/api/courses/${courseId}`,
        updatedData
      );
      if (response.data.success) {

        toast.success("Course updated successfully", tostifyOption);
       
        return response.data.course;
      } else {
        toast.error("⚠️ Failed to update course", tostifyOption);
      }
    } catch (error) {
      console.error("❌ Error updating course", error);
      toast.error("❌ An error occurred while updating the course", tostifyOption);
    }
  };

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });

  const getFilteredDate = (filter) => {
    const now = new Date();
    switch (filter) {
      case "lastWeek":
        return new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
      case "lastMonth":
        const lastMonth = new Date(now);
        lastMonth.setMonth(now.getMonth() - 1);
        return lastMonth;
      case "last3Months":
        const last3Months = new Date(now);
        last3Months.setMonth(now.getMonth() - 3);
        return last3Months;
      case "last6Months":
        const last6Months = new Date(now);
        last6Months.setMonth(now.getMonth() - 6);
        return last6Months;
      default:
        return null;
    }
  };

  // Fixed: Use dashboardData.transactions instead of undefined transactions
  const filteredTransactions =
    dashboardData?.transactions?.filter((transaction) => {
      // Search filter - by student name, transaction ID, or course name
      const matchesSearch =
        transaction.student
          ?.toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        transaction.studentUsername
          ?.toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        transaction.studentEmail
          ?.toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        transaction._id?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        transaction.courseName
          ?.toLowerCase()
          .includes(searchQuery.toLowerCase());

      // If no date filter is applied, return search matches
      if (!dateFilter) {
        return matchesSearch;
      }

      // Apply date filter if provided - filter by transaction date
      const filterDate = getFilteredDate(dateFilter);
      if (!filterDate) {
        return matchesSearch;
      }

      const transactionDate = new Date(transaction.date);

      // Handle invalid dates
      if (isNaN(transactionDate.getTime())) {
        return matchesSearch;
      }

      return matchesSearch && transactionDate >= filterDate;
    }) || [];

  const handleCSVDownload = () => {
    if (!filteredTransactions || filteredTransactions.length === 0) {
      alert("No transaction data to export.");
      return;
    }

    // Define headers for better CSV structure
    const headers = [
      "Date",
      "Time",
      "Transaction ID",
      "Student Name",
      "Student Username",
      "Student Email",
      "Course Name",
      "Amount",
    ];

    const csvRows = [
      headers.join(","), // Header row
      ...filteredTransactions.map((transaction) => {
        const dateObj = new Date(transaction.date);
        const date = dateObj.toLocaleDateString("en-US", {
          dateStyle: "medium",
        });
        const time = dateObj.toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        });

        const row = [
          date || "N/A",
          time || "N/A",
          transaction._id || "N/A",
          transaction.student || "N/A",
          transaction.studentUsername || "N/A",
          transaction.studentEmail || "N/A",
          transaction.courseName || "N/A",
          transaction.amount || "0",
        ];

        return row
          .map((field) => {
            const value = String(field).replace(/"/g, '""'); // Escape quotes
            return `"${value}"`;
          })
          .join(",");
      }),
    ];

    const csv = csvRows.join("\n");
    const blob = new Blob([csv], {
      type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `teacher_transactions_${
      new Date().toISOString().split("T")[0]
    }.csv`;
    a.click();

    URL.revokeObjectURL(url); // Clean up
  };

  const downloadTransactionsAsPDF = (transactionsData) => {
    if (!transactionsData || transactionsData.length === 0) {
      alert("No transaction data to export.");
      return;
    }

    const docDefinition = {
      pageSize: "A4",
      pageOrientation: "landscape",
      pageMargins: [25, 35, 25, 40],

      header: {
        margin: [25, 15, 25, 0],
        table: {
          widths: ["*", "auto"],
          body: [
            [
              {
                stack: [
                  { text: "AcademiaHub", style: "headerCompany" },
                  {
                    text: "Educational Management System",
                    style: "headerSubtitle",
                  },
                ],
                margin: [0, 5, 0, 0],
              },
              {
                stack: [
                  { text: "TRANSACTION REPORT", style: "headerTitle" },
                  {
                    text: `Generated: ${new Date().toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    })}`,
                    style: "headerDate",
                  },
                ],
                alignment: "right",
                margin: [0, 5, 0, 0],
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      content: [
        {
          margin: [0, 20, 0, 15],
          table: {
            widths: ["*", "*", "*", "*"],
            body: [
              [
                { text: "Total Transactions", style: "summaryLabel" },
                { text: "Total Amount", style: "summaryLabel" },
                { text: "Unique Students", style: "summaryLabel" },
                { text: "Unique Courses", style: "summaryLabel" },
              ],
              [
                {
                  text: transactionsData.length.toString(),
                  style: "summaryValue",
                },
                {
                  text: `$${transactionsData
                    .reduce((acc, tx) => acc + (parseFloat(tx.amount) || 0), 0)
                    .toFixed(2)}`,
                  style: "summaryValue",
                },
                {
                  text: new Set(
                    transactionsData.map((tx) => tx.student)
                  ).size.toString(),
                  style: "summaryValue",
                },
                {
                  text: new Set(
                    transactionsData.map((tx) => tx.courseName)
                  ).size.toString(),
                  style: "summaryValue",
                },
              ],
            ],
          },
          layout: {
            fillColor: (rowIndex) => (rowIndex === 0 ? "#34495e" : "#ecf0f1"),
            textColor: (rowIndex) => (rowIndex === 0 ? "white" : "#2c3e50"),
            hLineWidth: () => 0,
            vLineWidth: () => 0,
            paddingLeft: () => 8,
            paddingRight: () => 8,
            paddingTop: () => 6,
            paddingBottom: () => 6,
          },
        },

        {
          table: {
            headerRows: 1,
            widths: [30, 70, 60, 110, 100, 100, "*", 60],
            body: [
              [
                { text: "#", style: "tableHeader" },
                { text: "Date", style: "tableHeader" },
                { text: "Time", style: "tableHeader" },
                { text: "Transaction ID", style: "tableHeader" },
                { text: "Student", style: "tableHeader" },
                { text: "Course", style: "tableHeader" },
                { text: "Amount", style: "tableHeader" },
              ],
              ...transactionsData.map((tx, index) => {
                const dateObj = new Date(tx.date);
                const date = dateObj.toLocaleDateString("en-US", {
                  dateStyle: "medium",
                });
                const time = dateObj.toLocaleTimeString("en-US", {
                  hour: "numeric",
                  minute: "2-digit",
                  hour12: true,
                });

                return [
                  {
                    text: String(index + 1).padStart(3, "0"),
                    style: "cellData",
                    alignment: "center",
                    fillColor: "#f8f9fa",
                  },
                  {
                    text: date || "N/A",
                    style: "dateText",
                    alignment: "center",
                  },
                  {
                    text: time || "N/A",
                    style: "timeText",
                    alignment: "center",
                  },
                  { text: tx._id || "N/A", style: "cellData" },
                  {
                    stack: [
                      { text: tx.student || "N/A", style: "cellData" },
                      { text: tx.studentUsername || "", style: "timeText" },
                      { text: tx.studentEmail || "", style: "teacherEmail" },
                    ],
                  },
                  { text: tx.courseName || "N/A", style: "cellData" },
                  {
                    text: `$${(parseFloat(tx.amount) || 0).toFixed(2)}`,
                    style: "statsText",
                    alignment: "right",
                  },
                ];
              }),
            ],
          },
          layout: {
            fillColor: (rowIndex) =>
              rowIndex === 0
                ? "#2c3e50"
                : rowIndex % 2 === 0
                ? "#fdfdfd"
                : null,
            textColor: (rowIndex) => (rowIndex === 0 ? "white" : "#2c3e50"),
            hLineColor: "#bdc3c7",
            vLineColor: "#bdc3c7",
            hLineWidth: (i, node) =>
              i === 0 || i === node.table.body.length ? 1 : 0.5,
            vLineWidth: () => 0.5,
            paddingLeft: () => 4,
            paddingRight: () => 4,
            paddingTop: () => 4,
            paddingBottom: () => 4,
          },
        },
      ],

      footer: (currentPage, pageCount) => ({
        margin: [25, 10, 25, 0],
        table: {
          widths: ["*", "auto", "*"],
          body: [
            [
              {
                text: "AcademiaHub Educational Management System",
                style: "footerLeft",
              },
              {
                text: `Page ${currentPage} of ${pageCount}`,
                style: "footerCenter",
              },
              { text: "© 2025 - Confidential Document", style: "footerRight" },
            ],
          ],
        },
        layout: "noBorders",
      }),

      styles: {
        headerCompany: { fontSize: 18, bold: true, color: "#2c3e50" },
        headerSubtitle: { fontSize: 9, color: "#7f8c8d", italics: true },
        headerTitle: { fontSize: 16, bold: true, color: "#2c3e50" },
        headerDate: { fontSize: 8, color: "#7f8c8d" },

        summaryLabel: { fontSize: 9, bold: true, alignment: "center" },
        summaryValue: { fontSize: 14, bold: true, alignment: "center" },

        tableHeader: {
          fontSize: 9,
          bold: true,
          alignment: "center",
          color: "white",
        },
        cellData: { fontSize: 8, color: "#2c3e50" },
        dateText: { fontSize: 8, color: "#2c3e50", bold: true },
        timeText: { fontSize: 7, color: "#95a5a6" },
        teacherEmail: { fontSize: 7, color: "#7f8c8d", italics: true },
        statsText: { fontSize: 8, bold: true, color: "#27ae60" },

        footerLeft: { fontSize: 8, color: "#7f8c8d", alignment: "left" },
        footerCenter: {
          fontSize: 8,
          color: "#2c3e50",
          alignment: "center",
          bold: true,
        },
        footerRight: { fontSize: 8, color: "#7f8c8d", alignment: "right" },
      },
    };

    pdfMake
      .createPdf(docDefinition)
      .download(
        `AcademiaHub_Transaction_Report_${
          new Date().toISOString().split("T")[0]
        }.pdf`
      );
  };

  const handleDownloadChange = (e) => {
    const value = e.target.value;
    setDownloadOption(""); // Reset dropdown after selection

    if (value === "csv") {
      handleCSVDownload();
    } else if (value === "pdf") {
      downloadTransactionsAsPDF(filteredTransactions);
    }
  };
  // const toggleMenu = (e) => {
  //   e.stopPropagation(); // prevent card click
  //   setIsMenuOpen(!isMenuOpen);
  // };

  const toggleMenu = (e, courseId) => {
  e.stopPropagation();
  setMenuOpenId((prevId) => (prevId === courseId ? null : courseId));
};


  

  const handleDeleteCourse = (course) => {
    setCourseToDelete(course);
    setShowDeleteConfirm(true);
  };

  const confirmDelete = async () => {
    if (!courseToDelete) return;
    try {
      const response = await axios.delete(
        `${host}/api/courses/${courseToDelete._id}`
      );
      if (response.status === 200) {
        setCourses((prevCourses) =>
          prevCourses.filter((c) => c._id !== courseToDelete._id)
        );
        // Also update dashboardData.offeredCourses if needed
        setDashboardData((prev) => ({
          ...prev,
          offeredCourses: prev.offeredCourses.filter(
            (c) => c._id !== courseToDelete._id
          ),
        }));
        toast.success("Course deleted successfully");
      }
    } catch (error) {
      console.error("Failed to delete course:", error);
      toast.error("Failed to delete course");
    } finally {
      setShowDeleteConfirm(false);
      setCourseToDelete(null);
    }
  };

  const handleAddAvailability = () => {
  setAvailability([...availability, { day: "", slots: [] }]);
};

const handleDayChange = (index, value) => {
  const updatedAvailability = [...availability];
  updatedAvailability[index].day = value;
  setAvailability(updatedAvailability);
};

const handleAddSlot = (index) => {
  const updatedAvailability = [...availability];
  updatedAvailability[index].slots.push({ startTime: null, endTime: null });
  setAvailability(updatedAvailability);
};

const handleTimeChange = (index, slotIndex, field, time) => {
  if (!time) return;

  const updatedAvailability = [...availability];
  updatedAvailability[index].slots[slotIndex][field] = time.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  const startTime = updatedAvailability[index].slots[slotIndex].startTime;
  const endTime = updatedAvailability[index].slots[slotIndex].endTime;

  if (startTime && endTime) {
    try {
      const dividedSlots = splitTimeSlots(startTime, endTime);
      if (dividedSlots.length > 0) {
        updatedAvailability[index].slots = dividedSlots;
      }
    } catch (err) {
      console.error("Time slot splitting error:", err);
    }
  }

  setAvailability(updatedAvailability);
};

const splitTimeSlots = (startTime, endTime) => {
  const start = parseTime(startTime);
  const end = parseTime(endTime);

  if (!totalSessions || !duration) {
    alert("Please enter both total sessions and duration first.");
    return [];
  }

  const totalMinutes = (end - start) / (1000 * 60);
  const durationPerSession = (duration / totalSessions) * 60;

  const possibleSessions = Math.floor(totalMinutes / durationPerSession);
  let slots = [];

  for (let i = 0; i < possibleSessions; i++) {
    let sessionStart = new Date(start.getTime() + i * durationPerSession * 60 * 1000);
    let sessionEnd = new Date(sessionStart.getTime() + durationPerSession * 60 * 1000);

    slots.push({
      startTime: formatTime(sessionStart),
      endTime: formatTime(sessionEnd),
    });
  }

  return slots;
};

const formatTime = (date) => {
  return date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

const parseTime = (time) => {
  if (!time) return null;
  const match = time.match(/(\d+):(\d+) (AM|PM)/i);
  if (!match) return null;

  const [hour, minute, rawPeriod] = match.slice(1);
  let hours = parseInt(hour, 10);
  const minutes = parseInt(minute, 10);
  const period = rawPeriod.toUpperCase();

  if (period === "PM" && hours !== 12) hours += 12;
  if (period === "AM" && hours === 12) hours = 0;

  return new Date(1970, 0, 1, hours, minutes);
};


 
 
  
  return (
    <div
      className={`relative  ${
        dashboardData?.isVerified ? "min-h-screen" : ""
      } p-4 ${dashboardData ? "bg-gray-50" : "bg-white"}`}
    >
      {dashboardData && !dashboardData?.isVerified && (
        <div className="absolute inset-0 z-40 bg-gray-200 bg-opacity-60 backdrop-blur-sm flex flex-col items-center justify-center">
          <div className="flex flex-col items-center justify-center space-y-4 text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-16 w-16 text-gray-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={1.5}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 11c1.656 0 3-1.344 3-3V6a3 3 0 00-6 0v2c0 1.656 1.344 3 3 3zM4 11h16a1 1 0 011 1v7a2 2 0 01-2 2H5a2 2 0 01-2-2v-7a1 1 0 011-1z"
              />
            </svg>
            <h2 className="text-lg font-semibold text-gray-700">
              Account Not Verified
            </h2>
            <p className="text-sm text-gray-600 max-w-xs">
              You cannot access the dashboard until your account is verified by
              the admin.
            </p>
          </div>
        </div>
      )}
      {dashboardData && dashboardData?.isRejected && (
        <div className="absolute inset-0 z-40 bg-gray-200 bg-opacity-60 backdrop-blur-sm flex flex-col items-center justify-center">
          <div className="flex flex-col items-center justify-center space-y-4 text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-16 w-16 text-gray-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={1.5}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 11c1.656 0 3-1.344 3-3V6a3 3 0 00-6 0v2c0 1.656 1.344 3 3 3zM4 11h16a1 1 0 011 1v7a2 2 0 01-2 2H5a2 2 0 01-2-2v-7a1 1 0 011-1z"
              />
            </svg>
            <h2 className="text-lg font-semibold text-gray-700">
              Account Rejected
            </h2>
            <p className="text-sm text-gray-600 max-w-xs">
              You cannot access the dashboard because your account is rejected
              by the admin.
            </p>
          </div>
        </div>
      )}

      <h1 className="text-3xl font-bold mb-6">Teacher Dashboard</h1>

      {dashboardData ? (
        <>
          {/* Total earnings and add course button */}
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-6 gap-3">
  <h2 className="text-xl font-semibold text-center sm:text-left">
    Total Earnings: ${dashboardData.withdrawBalance.toFixed(2)}
  </h2>

  <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 w-full sm:w-auto">
    <button
      className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition w-full sm:w-auto"
      onClick={() => navigate("/withdraw")}
    >
      Withdraw
    </button>
    <button
      className="bg-indigo-500 text-white px-4 py-2 rounded hover:bg-indigo-600 transition w-full sm:w-auto"
      onClick={() => navigate("/add-course")}
    >
      Add Course
    </button>
  </div>
</div>

          {/* 📘 Offered Courses */}
          <div>
            <h2 className="text-2xl font-semibold mb-3">Offered Courses</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {dashboardData.offeredCourses.length > 0 ? (
                dashboardData.offeredCourses.map((course) => (
                  <div
                    key={course._id}
                    className="relative bg-white rounded-lg shadow p-4 hover:shadow-md transition cursor-pointer"
                    onClick={() => navigate(`/courses/${course._id}`)}
                  >
                    {/* Three Dots */}
<div className="absolute top-2 right-2 z-10">
  <button
    onClick={(e) => toggleMenu(e, course._id)}
    className="text-indigo-500 hover:text-indigo-700 font-bold text-2xl focus:outline-none"
  >
    ⋮
  </button>

  {/* Dropdown Menu */}
  {menuOpenId === course._id && (
    <div
      className="absolute right-0 mt-2 w-36 bg-white border border-gray-200 rounded-lg shadow-lg z-20 overflow-hidden"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
        onClick={() => {
          setEditingCourse(course);
          setIsModalOpen(true);
          setMenuOpenId(null);
        }}
      >
        <span className="ml-2">Edit</span>
      </button>
      <button
        className="flex items-center w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
        onClick={() => handleDeleteCourse(course)}
      >
        <span className="ml-2">Delete</span>
      </button>
    </div>
  )}
</div>


                    <img
                      src={course.image}
                      alt={course.title}
                      className="w-full h-40 object-cover rounded mb-3"
                    />
                    <h3 className="text-lg font-bold">{course.title}</h3>
                    <p className="text-sm text-gray-600">
                      {course.description}
                    </p>
                    <p className="mt-2 text-sm">
                      <strong>Price:</strong> ${course.price}
                    </p>
                    <p className="text-sm">
                      <strong>Sessions:</strong> {course.totalSessions}
                    </p>
                    <p className="text-sm">
                      <strong>Enrolled Students:</strong>{" "}
                      {course.students.length}
                    </p>
                  </div>
                ))
              ) : (
                <p className="text-gray-600">No courses found.</p>
              )}
            </div>
          </div>
          {isModalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto">
              <div className="bg-white rounded-lg p-6 w-full max-w-md max-h-[90vh] overflow-y-auto">
                <div className="bg-white rounded-lg p-6 w-full max-w-md">
                  <h3 className="text-lg font-semibold mb-4">
                    {editingCourse ? "Edit Course" : "Add New Course"}
                  </h3>

                  <form onSubmit={handleCourseSubmit} className="space-y-4">
                    <div className="mt-4">
  <label className="block text-sm font-medium text-gray-700">
    Course Image
  </label>

  {/* Preview image */}
  <img
    src={imagePreview || editingCourse?.image}
    alt="Preview"
    className="mt-2 w-full h-48 object-cover rounded border"
  />

  {/* Image file input */}
  <input
    type="file"
    accept="image/*"
    onChange={handleImageChange}
    className="mt-2 block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:border file:rounded-md file:border-gray-300 file:bg-gray-50 hover:file:bg-gray-100"
  />
</div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Course Name
                      </label>
                      <input
                        name="title"
                        type="text"
                        defaultValue={editingCourse?.title}
                        className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                        placeholder="Enter course name"
                        required
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Description
                      </label>
                      <textarea
                        name="description"
                        defaultValue={editingCourse?.description}
                        className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                        rows="4"
                        placeholder="Enter course description"
                        required
                      ></textarea>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Price (USD)
                      </label>
                      <input
                        name="price"
                        type="number"
                        step="0.01"
                        defaultValue={editingCourse?.price}
                        className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                        placeholder="Enter price"
                        required
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Total Sessions
                      </label>
                      <input
                        name="totalSessions"
                        type="number"
                        defaultValue={editingCourse?.totalSessions}
                        onChange={(e) => setTotalSessions(e.target.value)}
                        className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                        placeholder="Enter total sessions"
                        required
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Duration (hours)
                      </label>
                      <input
                        name="duration"
                        type="text"
                        defaultValue={editingCourse?.duration}
                        onChange={(e) => setDuration(e.target.value)}
                        className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                        placeholder="Enter duration (e.g., 1 hour)"
                        required
                      />
                    </div>

                   {/* Availability Section */}
<div>
  <label className="block text-sm font-medium text-gray-700">Availability</label>
  {availability.map((slot, index) => (
    <div key={index} className="mt-3 p-3 border rounded-md">
      {/* Weekday Selection */}
      <select
        value={slot.day}
        onChange={(e) => handleDayChange(index, e.target.value)}
        className="p-2 border rounded-md w-full"
        required
      >
        <option value="">Select Day</option>
        {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map((day) => (
          <option key={day} value={day}>{day}</option>
        ))}
      </select>

      {/* Time Slots */}
      {slot.slots.map((timeSlot, slotIndex) => (
        <div key={slotIndex} className="mt-2 flex space-x-2 mb-2">
          <DatePicker
            selected={parseTime(timeSlot.startTime)}
            onChange={(date) =>
              handleTimeChange(index, slotIndex, "startTime", date)
            }
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={15}
            dateFormat="h:mm aa"
            placeholderText="Start Time"
            className="border rounded-md px-2 py-1 w-full"
            required
          />
          <DatePicker
            selected={parseTime(timeSlot.endTime)}
            onChange={(date) =>
              handleTimeChange(index, slotIndex, "endTime", date)
            }
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={15}
            dateFormat="h:mm aa"
            placeholderText="End Time"
            className="border rounded-md px-2 py-1 w-full"
            required
          />
        </div>
      ))}

      <button
        type="button"
        onClick={() => handleAddSlot(index)}
        className="text-sm text-indigo-600 hover:underline mt-1"
      >
        + Add Time Slot
      </button>
    </div>
  ))}

  <button
    type="button"
    className="mt-2 text-sm text-indigo-600 hover:underline"
    onClick={handleAddAvailability}
  >
    + Add Day
  </button>
</div>


                    <div className="mt-6 flex justify-end gap-3">
                      <button
                        type="button"
                        onClick={() => {
                          setIsModalOpen(false);
                          setEditingCourse(null);
                        }}
                        className="px-4 py-2 border rounded-md text-gray-700 hover:bg-gray-50"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="px-4 py-2 bg-indigo-500 text-white rounded-md hover:bg-indigo-700"
                      >
                        {editingCourse ? "Update" : "Add"} Course
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}

          {/* Delete Confirmation Modal */}
          {showDeleteConfirm && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
              <div className="bg-white rounded-lg p-6 w-full max-w-sm">
                <h3 className="text-lg font-semibold mb-4">Confirm Delete</h3>
                <p className="text-gray-600 mb-6">
                  Are you sure you want to delete {courseToDelete.name}? This
                  action cannot be undone.
                </p>
                <div className="flex justify-end gap-3">
                  <button
                    onClick={() => {
                      setShowDeleteConfirm(false);
                      setCourseToDelete(null);
                    }}
                    className="px-4 py-2 border rounded-md text-gray-700 hover:bg-gray-50"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={confirmDelete}
                    className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* 👩‍🎓 Students List */}
          <div className="mt-10">
            <h2 className="text-2xl font-semibold mb-3">Students List</h2>
            <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {dashboardData.students.length > 0 ? (
                dashboardData.students.map((student, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-lg shadow p-4 flex flex-col items-center"
                  >
                    <img
                      src={student.avatar}
                      alt={student.name}
                      className="w-20 h-20 rounded-full object-cover mb-2"
                    />
                    <h3 className="text-md font-bold">{student.name}</h3>
                    <p className="text-sm text-gray-600">{student.email}</p>
                    <p className="text-sm mt-2">
                      <strong>Next Session:</strong>{" "}
                      {student.sessionStatus === "completed"
                        ? "🎉 Course Completed"
                        : student.sessionStatus === "missed"
                        ? "❌ Missed Session"
                        : student.nextSession
                        ? `${formatDate(student.nextSession.date)} | ${
                            student.nextSession.startTime
                          } - ${student.nextSession.endTime}`
                        : "No upcoming session"}
                    </p>

                    {/* Two buttons of profile and portal */}
                    <div className="flex gap-2 mt-3">
                      <button
                        className="bg-blue-500 text-white px-4 py-1 rounded hover:bg-blue-600 transition"
                        onClick={() => navigate(`/students/${student._id}`)}
                      >
                        Profile
                      </button>
                      <button
                        className="bg-green-500 text-white px-4 py-1 rounded hover:bg-green-600 transition"
                        onClick={() =>
                          navigate(
                            `/courses/${student.courseId}/${student._id}`
                          )
                        }
                      >
                        Portal
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-gray-600">No students found.</p>
              )}
            </div>
          </div>

          {/* Transaction History */}
          <div className="mt-10">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-semibold">Transaction History</h2>
              <div className="w-full md:w-auto">
                <select
                  onChange={handleDownloadChange}
                  value={downloadOption}
                  className="w-full md:w-auto bg-indigo-500 text-white font-bold py-2 px-4 rounded cursor-pointer"
                >
                  <option
                    value=""
                    disabled
                    className="text-black bg-white border-bottom"
                  >
                    Select download format
                  </option>
                  <option value="csv" className="text-black bg-white">
                    Download as CSV
                  </option>
                  <option value="pdf" className="text-black bg-white">
                    Download as PDF
                  </option>
                </select>
              </div>
            </div>

            {/* Search and Filters section */}
            <div className="flex flex-col md:flex-row gap-4 mb-4">
              <div className="flex w-full items-center justify-between gap-4">
                {/* Search Input */}
                <div className="relative flex-1">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                  <input
                    type="text"
                    placeholder="Search by student, course, or transaction ID..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="w-full pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                {/* Date Filter */}
                <select
                  value={dateFilter}
                  onChange={(e) => setDateFilter(e.target.value)}
                  className="border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">All Time</option>
                  <option value="lastWeek">Last Week</option>
                  <option value="lastMonth">Last Month</option>
                  <option value="last3Months">Last 3 Months</option>
                  <option value="last6Months">Last 6 Months</option>
                </select>
              </div>
            </div>

            {/* Show filtered results count */}
            {(searchQuery || dateFilter) && (
              <div className="mb-4 text-sm text-gray-600">
                Showing {filteredTransactions.length} of{" "}
                {dashboardData?.transactions?.length || 0} transactions
              </div>
            )}

            {filteredTransactions.length > 0 ? (
              <div className="overflow-auto rounded-lg border border-gray-200 shadow">
                <table className="min-w-full bg-white">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="px-6 py-3 text-left text-sm font-medium text-gray-700">
                        #
                      </th>
                      <th className="px-6 py-3 text-left text-sm font-medium text-gray-700">
                        Date
                      </th>
                      <th className="px-6 py-3 text-left text-sm font-medium text-gray-700">
                        Time
                      </th>
                      <th className="px-6 py-3 text-left text-sm font-medium text-gray-700">
                        Transaction Id
                      </th>
                      <th className="px-6 py-3 text-left text-sm font-medium text-gray-700">
                        Student
                      </th>
                      <th className="px-6 py-3 text-left text-sm font-medium text-gray-700">
                        Course
                      </th>
                      <th className="px-6 py-3 text-left text-sm font-medium text-gray-700">
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredTransactions.map((transaction, index) => {
                      const dateObj = new Date(transaction.date);
                      const date = dateObj.toLocaleDateString("en-US", {
                        dateStyle: "medium",
                      });
                      const time = dateObj.toLocaleTimeString("en-US", {
                        hour: "numeric",
                        minute: "2-digit",
                        hour12: true,
                      });
                      return (
                        <tr
                          key={transaction._id}
                          className="border-b hover:bg-gray-50"
                        >
                          <td className="px-6 py-4 text-sm text-gray-600">
                            {index + 1}
                          </td>
                          <td className="px-6 py-4 text-sm text-gray-600">
                            {date}
                          </td>
                          <td className="px-6 py-4 text-sm text-gray-600">
                            {time}
                          </td>
                          <td className="px-6 py-4 text-sm text-gray-600">
                            {transaction._id}
                          </td>
                          <td className="px-6 py-4 text-sm text-gray-600">
                            <div className="font-medium">
                              {transaction.student}
                            </div>
                            <div className="text-sm text-gray-500">
                              {transaction.studentUsername}
                            </div>
                            <div className="text-sm text-gray-400">
                              {transaction.studentEmail}
                            </div>
                          </td>
                          <td className="px-6 py-4 text-sm text-gray-600">
                            {transaction.courseName}
                          </td>
                          <td className="px-6 py-4 text-sm text-gray-600">
                            ${transaction.amount}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="text-gray-600">
                {dashboardData?.transactions?.length === 0
                  ? "No transactions found."
                  : "No transactions match your current filters."}
              </p>
            )}
          </div>
        </>
      ) : (
        <div className="flex items-center justify-center h-screen">
          <div className="w-80">
            <Lottie animationData={Loading} loop={true} />
          </div>
        </div>
      )}
    </div>
  );
};

export default TeacherDashboard;
